<template>
    <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
        <div slot="modal-header" class="w-100">
            <h5>{{title}}<button type="button" class="close"
                                 @click.prevent="closeModal()">
                <span aria-hidden="true">&times;</span></button>
            </h5>
        </div>
        <b-form>
            <div class="container-fluid visit-charge-body">
                <div class="row justify-content-center m-2">
                    <div class="alert alert-danger col" role="alert" v-show="generalErrorMessage">
                        <div>{{ generalErrorMessage }}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-2">
                    </div>
                    <div class="col-8">
                        <b-form-group :label-cols="4"
                                      label="Location"
                                      :state="stateForField('locationId')"
                                      :invalid-feedback="errorForField('locationId')"
                                      label-class="text-right">
                            <b-dropdown menu-class="dropdown-container" :text="locationName" :variant="hasError('locationId') ? 'outline-danger' : 'outline-dark'">
                                <b-dropdown-item v-for="location in locations" :key="location.locationId"
                                                 @click.prevent="setLocation(location)">{{ location.name + ' (' + location.type + ')' }}
                                </b-dropdown-item>
                            </b-dropdown>
                        </b-form-group>
                    </div>
                </div>
            </div>
        </b-form>
        <div slot="modal-footer" class="w-100">
            <button type="button" class="btn btn-orange float-right" @click.prevent="save()"><font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner"  pulse/>Update Estimate</button>
            <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
        </div>
    </b-modal>
</template>

<script>
  import ErrorsMixin from '../mixins/ErrorsMixin.js'

  export default {
    name: 'EstimateLocation',

    mixins: [ErrorsMixin],

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      currentLocationId: {
        type: Number,
        default: 0
      },

      title: {
        type: String,
        default: 'Change Location'
      }
    },

    data () {
      return {
        locationId: 0,
        isSaving: false
      }
    },

    watch: {
      visible (newValue, oldValue) {
        if (newValue) {
          this.clearData()
        }
      }
    },

    computed: {
      providers () {
        return this.$store.organization.providers
      },

      locations () {
        return this.$store.organization.locations
      },

      locationName () {
        if (this.locationId) {
          const currentLocation = this.locations.filter(aLocation => {
            return aLocation.locationId === this.locationId
          }).shift()

          if (currentLocation) {
            return currentLocation.name
          }
        }

        return 'Click to Select'
      }

    },

    methods: {
      clearData () {
        this.clearAllErrors()
        this.locationId = this.currentLocationId
      },

      validate () {
        this.clearAllErrors()

        if (!this.locationId > 0) {
          this.addErrorForField('locationId', 'You must select a location')
        }

        return !this.hasErrors()
      },

      setLocation (location) {
        this.locationId = location.locationId
      },

      save () {
        if (!this.validate()) {
          return
        }

        this.$emit('locationSelected', this.locationId)
      },

      closeModal () {
        this.$emit('update:visible', false)
      }
    }
  }
</script>

<style scoped>
    .visit-charge-body {
        font-size: 16px;
    }

    .current-charge .fa-trash-alt {
        cursor: pointer;
    }

    .current-charge .fa-trash-alt:HOVER {
        color: rgb(255, 70, 0);
    }

</style>
